import { render, staticRenderFns } from "./FoodPos.vue?vue&type=template&id=968ac658&scoped=true&"
import script from "./FoodPos.vue?vue&type=script&lang=js&"
export * from "./FoodPos.vue?vue&type=script&lang=js&"
import style0 from "./FoodPos.vue?vue&type=style&index=0&id=968ac658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968ac658",
  null
  
)

export default component.exports